import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=702ed154&scoped=true&"
import script from "./ProductNew.vue?vue&type=script&lang=js&"
export * from "./ProductNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=702ed154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ed154",
  null
  
)

export default component.exports